import { render } from "./FileChooser.vue?vue&type=template&id=20880759&scoped=true&ts=true"
import script from "./FileChooser.vue?vue&type=script&lang=ts"
export * from "./FileChooser.vue?vue&type=script&lang=ts"

import "./FileChooser.vue?vue&type=style&index=0&id=20880759&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20880759"]])

export default __exports__